/*
 * Purpose: Sync ?flow= query to workflowStore on navigation
 * Last modified: 2026-06-28 | Agent
 * Completeness: 90
 */
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useWorkflowStore } from '@/stores/workflowStore';

export function FlowQuerySync() {
  const [params] = useSearchParams();
  const flowId = params.get('flow');

  useEffect(() => {
    if (!flowId) return;
    const wf = useWorkflowStore.getState().workflows.find((w) => w.id === flowId);
    if (wf) useWorkflowStore.getState().setCurrentWorkflow(wf);
  }, [flowId]);

  return null;
}

export default FlowQuerySync;
